import { Stack, Typography } from '@mui/material';
import { InsufficientFeedbackForSummaryIcon } from '../InsufficientFeedbackForSummaryIcon';

export const EmptySummaryContent = () => {
  return (
    <Stack
      display="flex"
      alignItems="center"
      justifyContent="center"
      direction="row"
      spacing={1}
    >
      <InsufficientFeedbackForSummaryIcon />
      <Typography variant="h6" color="text.disabled">
        Insufficient feedback records to generate a summary
      </Typography>
    </Stack>
  );
};
